import { createRoot } from 'react-dom/client';
import { PostHogProvider } from 'posthog-js/react';
import App from './App.tsx';
import './index.css';

// PostHog 配置选项
const posthogOptions = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  person_profiles: 'identified_only', // 仅为已识别用户创建配置文件
  loaded: (posthog) => {
    if (import.meta.env.DEV) {
      console.log('[PostHog] Initialized successfully');
    }
  },
};

createRoot(document.getElementById('root')!).render(
  <PostHogProvider 
    apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
    options={posthogOptions}
  >
    <App />
  </PostHogProvider>
);
